


import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  props: {
    standbyTypes: { type: Array as PropType<string[]>, required: true },
    standbyType: { type: String, required: true },
    label: { type: String, required: true },
  },
  emits: ['update:standbyType'],
  setup(_props, { emit }) {
    const updateStandbyType = (standbyType: string): void => {
      emit('update:standbyType', standbyType);
    };

    return {
      updateStandbyType,
    };
  },
});
